import { newCouponBg, newCouponColor } from '@bingads-webui-react/auto-performance-coupon-lightbox';

const MDLI2Icon = content => ({
  fontFamily: 'MsAds MDL2 Assets',
  '&:before': {
    content: `"\\${content}"`,
  },
});

const couponIcon = {
  ...MDLI2Icon('F7BC'),
  verticalAlign: 'middle',
  marginRight: 5,
};
export const bannerStyles = {
  couponIcon,
  actionButtonStyle: {
    color: '#323130',
    height: 24,
    display: 'inline-block',
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '14px',
    padding: '4px 23px',
    marginLeft: '15px',
    background: '#FFFFFF',
    border: '1px solid #C8C6C4',
    boxSizing: 'border-box',
    borderRadius: '2px',
    position: 'relative',
    clear: 'both',
    marginTop: '6px',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: 'rgb(237, 235, 233)',
    },
  },
  topBanner: {
    background: newCouponBg,
    padding: '0px 10px 0px 8px',
    lineHeight: '36px',
    height: '37px',
    borderBottom: '1px solid #e1dfdd',
    display: 'flex',
  },
  alert: {
    color: '#FFFFFF',
  },
};

export const inlineDetailsStyles = {
  inlineCouponDetails: {
    width: '100%',
    border: newCouponBg,
    borderStyle: 'dashed',
    padding: 5,
    color: newCouponColor,
    marginTop: 10,
  },
  couponIcon,
  inlineCouponDetailsText: {
    fontWeight: 'bold',
  },
};

const tagHeight = 24;
const flyoutOffset = 16;

export const tagStyles = {
  tag: {
    display: 'flex',
  },
  tagWithExtension: {
    '&:hover $flyout': {
      display: 'flex',
    },
    color: 'white',
    display: 'flex',
    position: 'relative',
    height: tagHeight,
    width: 'fit-content',
    float: 'right',
  },
  mainTriangle: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    marginRight: -1,
    borderWidth: [tagHeight / 2, 10],
    borderColor: [newCouponBg, newCouponBg, newCouponBg, 'transparent'],
  },
  mainContainer: {
    backgroundColor: newCouponBg,
    height: tagHeight,
    padding: [5, 10, 5, 0],
    fontSize: 10,
    boxSizing: 'border-box',
    fontWeight: 'normal',
  },
  clearFloats: {
    content: '" "',
    display: 'table',
    clear: 'both',
    marginBottom: -20,
  },
  flyout: {
    display: 'none',
    position: 'absolute',
    '&.left': {
      right: '100%',
    },
    '&.right': {
      left: '100%',
    },
    top: -flyoutOffset,
  },
  flyoutContent: {
    '$flyout.left &': {
      '&:after,&:before': {
        left: '100%',
      },
      transform: 'translate3d(-12px, 0, 1px)',
      '-webkit-transform': 'translate3d(-12px, 0, 1px)',
    },
    '$flyout.right &': {
      '&:after,&:before': {
        right: '100%',
      },
      transform: 'translate3d(12px, 0, 1px)',
      '-webkit-transform': 'translate3d(12px, 0, 1px)',
    },
    '&:after, &:before': {
      top: flyoutOffset + (tagHeight / 2),
      border: 'solid transparent',
      content: '" "',
      height: 0,
      width: 0,
      position: 'absolute',
      pointerEvents: 'none',
    },
    '&:after': {
      borderWidth: 10.5,
      marginTop: -10.5,
      '$flyout.left &': {
        borderColor: ['transparent', 'transparent', 'transparent', 'white'],
        marginLeft: -0.5,
      },
      '$flyout.right &': {
        borderColor: ['transparent', 'white', 'transparent', 'transparent'],
        marginRight: -0.5,
      },
    },
    '&:before': {
      borderWidth: 12,
      marginTop: -12,
      '$flyout.left &': {
        borderColor: ['transparent', 'transparent', 'transparent', 'lightgrey'],
      },
      '$flyout.right &': {
        borderColor: ['transparent', 'lightgrey', 'transparent', 'transparent'],
      },
    },
    position: 'relative',
    backgroundColor: 'white',
    border: '1px solid lightgrey',
    padding: 10,
    color: 'black',
    width: 280,
    boxShadow: '3px 3px 4px #dddddd',
  },
  flyoutContentLine1: {
    fontWeight: 'bold',
  },
  flyoutContentLine2: {
    color: 'red',
    marginBottom: 0,
  },
};

export const couponLightboxStepStyles = {
  block: {
    flexBasis: 0,
    flexGrow: 1,
    '&:not(:first-child)': {
      marginLeft: 50,
    },
  },
  icon: {
    textAlign: 'center',
    display: 'block',
    margin: 'auto',
    marginBottom: 20,
    height: 100,
  },
  titleStepNumber: {
    fontWeight: 'bold',
  },
};

export const couponLightboxStyles = {
  steps: {
    display: 'flex',
    marginBottom: 20,
  },
};

export const lightboxStyles = {
  lightbox: {
    background: '2px solid #CCC',
  },
  overlay: {
    position: 'fixed',
    backgroundColor: 'rgba(0,0,0,0.3125)',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    top: 0,
    left: 0,
    right: 0,
    bottom: 0,

    width: '100%',
    height: '100%',

    zIndex: 1099,
  },
  container: {
    backgroundColor: 'white',
    width: 640,
    padding: 20,
  },
  title: {
    marginTop: 0,
    marginBottom: 30,
    fontWeight: 'bold',
    fontSize: '1.17em',
  },
  body: {
    paddingBottom: 20,
  },
  footer: {
    background: '#ffffff',
  },
  buttonOk: {
    padding: [5, 35],
  },
};
